import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import Header from "../common/Header";
import { Button, Form, Input, InputNumber, Select } from "antd";
import UploadInput from "../common/upload/UploadInput";
import { LoadingOutlined } from "@ant-design/icons";
import "../common/forms.css";

const AddRoomPage = () => {
  const navigate = useNavigate();
  const [roomDetails, setRoomDetails] = useState();
  const [roomTypes, setRoomTypes] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [newRoomType, setNewRoomType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();

  useEffect(() => {
    const fetchRoomTypes = async () => {
      try {
        const types = await ApiService.getRoomTypes();
        const hotels = await ApiService.fetchHotels();
        setRoomTypes(types);
        let hotelSelectOptions = hotels.map((hotel) => {
          return {
            label: hotel.name,
            value: hotel.id,
          };
        });
        setHotels(hotelSelectOptions);
      } catch (error) {
        console.error("Error fetching room types:", error.message);
      }
    };
    fetchRoomTypes();
    if (location) {
      setRoomDetails(location.state?.room);
      form.setFieldsValue(location.state?.hotel);
    }
  }, [form, location]);

  const handleRoomTypeChange = (e) => {
    if (e === "new") {
      setNewRoomType(true);
    } else {
      setNewRoomType(false);
    }
  };

  const addRoom = async (values) => {
    if (!window.confirm("Do you want to add this room?")) {
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("roomType", values.roomType);
    formData.append("roomName", values.roomName);
    formData.append("roomPrice", values.roomPrice);
    formData.append("roomDescription", values.roomDescription);
    formData.append("hotelId", values.hotel);
    formData.append("maxPersons", values.maxPersons);

    if (values.photo && values.photo.length > 0) {
      formData.append("photo", values.photo[0].originFileObj);
    }

    const result = await ApiService.addRoom(formData);

    if (result) {
      setTimeout(() => {
        navigate("/admin/manage-rooms");
      }, 1000);
    }
    setLoading(false);
  };

  return (
    <div className="default-container">
      <Header title={"Add New Room"} />
      <div className="form-page-container">
      <Form
        className="form"
        name="hotel-form"
        initialValues={roomDetails}
        onFinish={addRoom}
        form={form}
        layout="vertical"
      >
        <Form.Item
          name={"photo"}
          label="Photo of the room"
          rules={[{ required: true, message: "This field is required" }]}
          getValueFromEvent={(e) => e}
          valuePropName="value"
        >
          <UploadInput
            allowedFileTypes={["image/png", "image/jpg", "image/jpeg"]}
            name={"roomPhoto"}
          />
        </Form.Item>

        <Form.Item
          name={"hotel"}
          label="Hotel"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Select options={hotels} size="large" />
        </Form.Item>

        <Form.Item
          name={"roomName"}
          label="Room Name"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input size="large" />
        </Form.Item>

        <Form.Item
          name={"roomType"}
          label="Room Type"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Select onChange={handleRoomTypeChange} size="large">
            {roomTypes.map((type) => {
              return (
                <Select.Option value={type} key={type}>
                  {type}
                </Select.Option>
              );
            })}
            <Select.Option value="new" key="other_rooom_type">
              Other (Please Specify)
            </Select.Option>
          </Select>
        </Form.Item>
        {newRoomType && (
          <Form.Item
            name={"roomType"}
            label="New Room Type Name"
            rules={[
              { required: newRoomType, message: "This field is required" },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        )}
        <Form.Item
          label="Room Cost per Night"
          name="roomPrice"
          rules={[
            {
              required: true,
              message: "This field is required",
            },
            {
              validator: (_, value) =>
                value >= 1
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error("Value must be greater than or equal to 1")
                    ),
            },
          ]}
        >
          <InputNumber size="large" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Max Persons"
          name="maxPersons"
          rules={[
            { required: true, message: "This field is required" },
            {
              validator: (_, value) =>
                value >= 1
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error("Value must be greater than or equal to 1")
                    ),
            },
          ]}
        >
          <InputNumber size="large" style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Description"
          name="roomDescription"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input.TextArea rows={5} size="large" />
        </Form.Item>
        <Form.Item className="action-button-default">
          <Button htmlType="submit" type="primary" disabled={loading}>
            {loading ? <LoadingOutlined /> : `Add Room`}
          </Button>
        </Form.Item>
      </Form>
      </div>
    </div>
  );
};

export default AddRoomPage;
